export const KEY_GOOGLE_MAP = 'AIzaSyA_FcrjelX64BZho-3P8JL35paCmegG7bk';
